import {
  AppBar,
  Box,
  Button,
  Container,
  Drawer,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Stack,
  Toolbar,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { List as ListIcon, X } from "phosphor-react";
import { useState } from "react";
import LogoSection from "../../../../components/LogoSection";
import ProfileSection from "../../../../components/ProfileSection";
import { useAuth } from "../../../../hooks/useAuth";
import { useAuthenticatedUser } from "../../../../store/user";

interface IHomeNavbar {
  dark?: boolean;
}

export const HomeNavbar = ({ dark = true }: IHomeNavbar) => {
  const theme = useTheme();

  const matchUpMd = useMediaQuery(theme.breakpoints.up("md"));
  const { data: user } = useAuthenticatedUser();
  const { signOut, isLoading } = useAuth();

  const handleLogout = async () => {
    await signOut();
  };

  const [open, setOpen] = useState<boolean>(false);
  const pages = [
    {
      id: "2",
      title: "Agendar exame/consulta",
      url: "/agendamento",
    },
  ];

  const handleOpen = () => {
    setOpen((old) => !old);
  };

  return (
    <AppBar
      position="relative"
      elevation={0}
      sx={{
        backgroundColor: (theme) =>
          dark ? theme.palette.primary.main : theme.palette.background.default,
      }}
    >
      <Container maxWidth="lg">
        <Toolbar disableGutters>
          <Grid
            container
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid
              item
              xl={3}
              lg={3}
              md={3}
              xs={4}
              alignItems="center"
              display="flex"
            >
              <LogoSection dark={!dark} />
            </Grid>

            {matchUpMd && (
              <Grid
                item
                xl={6}
                lg={6}
                md={6}
                alignItems="center"
                display="flex"
                justifyContent="flex-end"
              >
                {pages.map((page) => (
                  <Button
                    key={page.id}
                    href={page.url}
                    sx={{
                      color: dark
                        ? "white"
                        : theme.palette.onSurfaceVariant.main,
                      display: "block",
                    }}
                  >
                    {page.title}
                  </Button>
                ))}
              </Grid>
            )}
            {matchUpMd ? (
              <ProfileSection />
            ) : (
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={() => handleOpen()}
                color={dark ? "inherit" : "primary"}
              >
                <ListIcon size={32} />
              </IconButton>
            )}
          </Grid>
        </Toolbar>
      </Container>
      {!matchUpMd && (
        <Box
          sx={{
            width: "auto",
            backgroundColor: (theme) => theme.palette.background.default,
          }}
          role="presentation"
          onClick={() => handleOpen()}
          onKeyDown={() => handleOpen()}
        >
          <Drawer anchor="top" open={open} onClose={() => handleOpen()}>
            <Box
              display="flex"
              flexDirection="row"
              alignItems="center"
              justifyContent="space-between"
              sx={{
                p: 2,
              }}
            >
              <LogoSection dark={true} />
              <IconButton>
                <X />
              </IconButton>
            </Box>
            {user ? (
              <>
                <Box
                  display="flex"
                  flexDirection="row"
                  alignItems="center"
                  justifyContent="center"
                  sx={{
                    p: 2,
                  }}
                >
                  <Stack direction="row" spacing={0.5} alignItems="center">
                    <Typography>Olá,</Typography>
                    <Typography sx={{ fontWeight: 600 }}>
                      {user.paciente.nomepaciente}
                    </Typography>
                  </Stack>
                </Box>
                <List>
                  <ListItem disablePadding>
                    <ListItemButton href="/paciente/dashboard">
                      <ListItemText
                        primary="Meus Agendamentos"
                        sx={{
                          textAlign: "center",
                        }}
                      />
                    </ListItemButton>
                  </ListItem>
                  <ListItem disablePadding>
                    <ListItemButton href="/paciente/dashboard/minha-conta">
                      <ListItemText
                        primary="Minha Conta"
                        sx={{
                          textAlign: "center",
                        }}
                      />
                    </ListItemButton>
                  </ListItem>
                  <ListItem disablePadding>
                    <ListItemButton disabled={isLoading} onClick={handleLogout}>
                      <ListItemText
                        primary="Sair"
                        sx={{
                          textAlign: "center",
                        }}
                      />
                    </ListItemButton>
                  </ListItem>
                </List>
              </>
            ) : (
              <List>
                <ListItem disablePadding>
                  <ListItemButton href="/login">
                    <ListItemText
                      primary="Login"
                      sx={{
                        textAlign: "center",
                      }}
                    />
                  </ListItemButton>
                </ListItem>
              </List>
            )}
            <Box
              display="flex"
              flexDirection="row"
              justifyContent="center"
              sx={{
                p: 2,
              }}
            >
              <Tooltip title="Criar evento">
                <Button
                  variant="contained"
                  color="secondary"
                  disableElevation
                  href="/agendamento"
                >
                  Agendar consulta/exame
                </Button>
              </Tooltip>
            </Box>
          </Drawer>
        </Box>
      )}
    </AppBar>
  );
};
